import React from 'react';
const Success = (props) => {
    return (
        <div className={`message-box`}>
            {props.success ? <p className={`success`}>Your request is submitted.</p> : ''}
            {props.error ? <p className={`error`}>Something went wrong. Please try again later.</p> : ''}
        </div>
    );
}

export default Success;